import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../component/shared/shared.service";
import { User } from "../model/user";
import { UserService } from "../service/user.service";
import {
  DialogAction,
  ActionMessage
} from "../../../shared/enum/dialog-action.enum";
@Component({
  selector: "app-view-users",
  templateUrl: "./view-users.component.html"
})
export class ViewUsersComponent implements OnInit {
  usrData: User = new User(null, "", "", "", null, 0);
  loading: boolean = false;
  listLoading: boolean = false;
  message: string = "";
  Users: User[];
  UsersData: User[];
  selectedObject: User;
  isAdd: boolean = true;
  user: any;
  selectUser: string = "0";
  constructor(
    private _sharedService: SharedService,
    private _usrService: UserService
  ) {
    this.isAdd = true;
    _sharedService.yesEmitted$.subscribe(text => {
      if (
        text.Action === DialogAction.DELETE.toString() &&
        text.Page === "USER"
      ) {
        this.selectedObject = text.Data;
        this.delete();
      } else {
        this.clearData();
      }
    });
  }

  setFilterUser() {
    if (this.selectUser == "0") {
      this.Users = this.UsersData;
    } else {
      this.Users = this.UsersData.filter(
        item => item.UserRoleId == parseInt(this.selectUser)
      );
    }
  }

  clearData(): void {
    this.usrData.UserName = "";
    this.usrData.UserPassword = null;
    this.usrData.UserRoleId = null;
    this.usrData.UserRole = "";
    this.isAdd = true;
  }
  saveUser(): void {
    this.loading = true;
    this._usrService.data = this.usrData;
    if (this.isAdd) {
      this.addUser();
    } else {
      this.updateUser();
    }
  }
  addUser(): void {
    this._usrService.saveUser().subscribe(
      data => {
        this.loading = false;
        this.message = "User " + ActionMessage.SAVESUCCESS.toString();
        this.clearData();
        this.getUsers();
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  updateUser(): void {
    this.loading = true;
    this._usrService.updateUser().subscribe(
      data => {
        this.loading = false;
        this.message = "User " + ActionMessage.UPDATESUCCESS.toString();
        this.clearData();
        this.getUsers();
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  delete(): void {
    this.loading = true;
    this._usrService.deleteUser(this.selectedObject).subscribe(
      data => {
        this.listLoading = false;
        this.message = "User " + ActionMessage.DELETESUCCESS.toString();
        this.clearData();
        this.getUsers();
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  cancelData(): void {
    if (this.isAdd) {
      this.clearData();
    } else {
      this._sharedService.emitDialog(
        true,
        "Cancel",
        ActionMessage.CANCEL.toString(),
        true,
        DialogAction.CANCEL.toString(),
        "USER"
      );
    }
  }
  deleteUser(usr: any): void {
    if (usr.UserActive == 0) {
      this.selectedObject = usr;
      this._sharedService.emitDialog(
        true,
        "Delete",
        ActionMessage.DELETE.toString(),
        true,
        DialogAction.DELETE.toString(),
        "USER",
        this.selectedObject
      );
    } else {
      this._sharedService.emitDialog(
        true,
        "Alert",
        "Please deactivete user first before delete!",
        true,
        DialogAction.ALERT.toString(),
        "USER",
        null
      );
    }
  }
  editUser(orgEditObject: User): void {
    this.isAdd = false;
    this.usrData = Object.assign(Object.create(orgEditObject), orgEditObject);
  }
  getUsers(): void {
    this.loading = true;
    this._usrService.getUsers().subscribe(
      data => {
        this.loading = false;
        this.Users = data.filter(item => item.IsDeleted == 0);
        this.UsersData = data.filter(item => item.IsDeleted == 0);
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.getUsers();
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  bookAppointment(usr: User) {
    this._sharedService.overlay({
      module: "USER",
      type: "Appointment",
      isShow: true,
      data: usr,
      secondData: null
    });
  }
  showHide(usr) {
    this.loading = true;
    if (usr.IsShow == 0) {
      usr.IsShow = 1;
    } else {
      usr.IsShow = 0;
    }
    usr["messageText"] = "";
    usr["loading"] = true;
    this._usrService.data = usr;
    this._usrService.updateUserStatus().subscribe(
      data => {
        this.loading = false;
        this.message = "User " + ActionMessage.UPDATESUCCESS.toString();
        usr["messageText"] =
          usr.IsShow == 0
            ? "Expert hidden successfully"
            : "Expert shown successfully";
        usr["loading"] = false;
        setTimeout(() => {
          usr["messageText"] = "";
        }, 10000);
        this.clearData();
        this.getUsers();
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }

  recommendUser(usr) {
    this.loading = true;
    if (usr.IsRecommended == 0) {
      usr.IsRecommended = 1;
    } else {
      usr.IsRecommended = 0;
    }
    usr["messageText"] = "";
    usr["loading"] = true;
    this._usrService.data = usr;
    this._usrService.updateUserCommStatus().subscribe(
      data => {
        this.loading = false;
        this.message = "User " + ActionMessage.UPDATESUCCESS.toString();
        usr["messageText"] =
          usr.IsRecommended == 0
            ? "Expert removed from recommendation"
            : "Expert recommended successfully";
        usr["loading"] = false;
        setTimeout(() => {
          usr["messageText"] = "";
        }, 10000);
        this.clearData();
        this.getUsers();
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  updateUserComm(usr) {
    this.loading = true;
    usr["messageText"] = "";
    usr["loading"] = true;
    this._usrService.data = usr;
    this._usrService.updateUserCommStatus().subscribe(
      data => {
        this.loading = false;
        this.message = "User " + ActionMessage.UPDATESUCCESS.toString();
        usr["messageText"] = "Expert fee charges updated successfully.";
        usr["loading"] = false;
        setTimeout(() => {
          usr["messageText"] = "";
        }, 10000);
        this.clearData();
        this.getUsers();
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }

  activateDeactivateUser(usr) {
    this.loading = true;
    if (usr.UserActive == 0) {
      usr.UserActive = 1;
    } else {
      usr.UserActive = 0;
    }
    usr["messageText"] = "";
    usr["loading"] = true;
    this._usrService.data = usr;
    this._usrService.updateUserStatus().subscribe(
      data => {
        this.loading = false;
        this.message = "User " + ActionMessage.UPDATESUCCESS.toString();
        usr["messageText"] =
          usr.UserActive == 0
            ? "Expert deactivated successfully"
            : "Expert activated successfully";
        usr["loading"] = false;
        setTimeout(() => {
          usr["messageText"] = "";
        }, 10000);
        this.clearData();
        this.getUsers();
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/section/user/view-users/view-users.component.ts